export const BUSINESSTYPES = [
  {
    title: "Business",
    slug: "business",
  },
  {
    title: "Content Creator/Advertiser",
    slug: "creator",
  },
];

export const BUSINESSROLES = [
  {
    title: "CEO",
    slug: "ceo",
  },
  {
    title: "CTO",
    slug: "cto",
  },
  {
    title: "CMO",
    slug: "cmo",
  },
  {
    title: "Marketing lead",
    slug: "marketing-lead",
  },
  {
    title: "Other",
    slug: "other",
  },
];

export const BUSINESSINDUSTRIES = [
  {
    title: "Advertising",
    slug: "advertising",
  },
  {
    title: "Agriculture",
    slug: "agriculture",
  },
  {
    title: "AI and Machine Learning",
    slug: "ai-machine-learning",
  },
  {
    title: "Architecture",
    slug: "architecture",
  },
  {
    title: "Beauty",
    slug: "beauty",
  },
  {
    title: "Blockchain",
    slug: "blockchain",
  },
  {
    title: "Construction",
    slug: "construction",
  },
  {
    title: "Consulting",
    slug: "consulting",
  },
  {
    title: "Content Creator/Advertiser",
    slug: "creator",
  },
  {
    title: "Cybersecurity",
    slug: "cybersecurity",
  },
  {
    title: "E-commerce",
    slug: "e-commerce",
  },
  {
    title: "Education",
    slug: "education",
  },
  {
    title: "Energy",
    slug: "energy",
  },
  {
    title: "Environmental",
    slug: "environmental",
  },
  {
    title: "Event Planning",
    slug: "event-planning",
  },
  {
    title: "Fashion",
    slug: "fashion",
  },
  {
    title: "Finance",
    slug: "finance",
  },
  {
    title: "Fitness",
    slug: "fitness",
  },
  {
    title: "Food and Beverage",
    slug: "food-beverage",
  },
  {
    title: "Gaming",
    slug: "gaming",
  },
  {
    title: "Graphic Design",
    slug: "graphic-design",
  },
  {
    title: "Healthcare",
    slug: "healthcare",
  },
  {
    title: "Hospitality",
    slug: "hospitality",
  },
  {
    title: "Human Resources",
    slug: "human-resources",
  },
  {
    title: "Insurance",
    slug: "insurance",
  },
  {
    title: "Interior Design",
    slug: "interior-design",
  },
  {
    title: "Legal",
    slug: "legal",
  },
  {
    title: "Manufacturing",
    slug: "manufacturing",
  },
  {
    title: "Marketing and Advertising",
    slug: "marketing-advertising",
  },
  {
    title: "Music",
    slug: "music",
  },
  {
    title: "Non-profit",
    slug: "non-profit",
  },
  {
    title: "Photography",
    slug: "photography",
  },
  {
    title: "Public Relations",
    slug: "public-relations",
  },
  {
    title: "Real Estate",
    slug: "real-estate",
  },
  {
    title: "Retail",
    slug: "retail",
  },
  {
    title: "Social Media",
    slug: "social-media",
  },
  {
    title: "Software Development",
    slug: "software-development",
  },
  {
    title: "Sports and Fitness",
    slug: "sports-fitness",
  },
  {
    title: "Technology",
    slug: "technology",
  },
  {
    title: "Telecommunications",
    slug: "telecommunications",
  },
  {
    title: "Transportation",
    slug: "transportation",
  },
  {
    title: "Travel",
    slug: "travel",
  },
  {
    title: "Virtual Reality",
    slug: "virtual-reality",
  },
  {
    title: "Wedding Planning",
    slug: "wedding-planning",
  },
];
